import { render, staticRenderFns } from "./UpcomingCrawlsWidget.vue?vue&type=template&id=32c5db23&"
import script from "./UpcomingCrawlsWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingCrawlsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports